/**
 * Main page implementation.
 */

'use strict';


var app          = require('mag-app'),
    Page         = require('stb-component-page'),
    keys         = require('stb-keys'),
    Footer       = require('mag-component-footer'),
    ModalMessage = require('mag-component-modal'),
    Scroll       = require('stb-component-scrollbar'),
    ScrollArea   = require('mag-component-scroll-area'),
    page         = new Page({$node: window.pageEula}),
    popup        = null;


page.once('show', function () {
    // eslint-disable-next-line handle-callback-err
    require('../modules/device.api').model(function ( error, model ) {
        var scroll = new Scroll();

        page.add(page.modal = new ModalMessage({
            title: gettext('TERMS AND CONDITIONS OF USE'),
            visible: true,
            className: 'main',
            children: [
                page.scrollArea = new ScrollArea({
                    events: {
                        overflow: function ( event ) {
                            if ( event.direction === keys.down ) {
                                page.footer.init({
                                    middle: [
                                        {
                                            code: keys.back,
                                            title: gettext('Reject the license agreement'),
                                            action: function () {
                                                if ( popup === null ) {
                                                    popup = require('../components/popup.menu');
                                                }

                                                popup.show();
                                            }
                                        },
                                        {
                                            code: keys.ok,
                                            title: gettext('Accept the license agreement'),
                                            action: function () {
                                                if ( popup === null || (!popup.visible) ) {
                                                    app.licenseAgree = true;
                                                    app.route(app.pages.main);
                                                }
                                            }
                                        }
                                    ]
                                });
                            }
                        },
                        keydown: function ( event ) {
                            switch ( event.code ) {
                                case keys.up:
                                case keys.down:

                                    console.log('before');
                                    console.log(this.realHeight);
                                    console.log(this.viewHeight);
                                    this.realHeight = this.$body.offsetHeight;
                                    this.viewHeight = this.$node.offsetHeight;
                                    console.log('after');
                                    console.log(this.realHeight);
                                    console.log(this.viewHeight);

                                    this.scroll.init({
                                        realSize: this.realHeight,
                                        viewSize: this.viewHeight,
                                        value: this.topPosition * -1
                                    });

                                    this.move(event.code);
                                    break;
                            }
                        }
                    }
                })
            ],
            events: {
                hide: function () {
                    setTimeout(function () {
                        page.modal.show();
                        page.scrollArea.focus();
                    });
                }
            }
        }));

        page.scrollArea.$node.appendChild(scroll.$node);

        page.scrollArea.$body.innerHTML = '<p>Please read these Terms and Conditions of Use (the “Terms”) ' +
            'carefully before using this Ministra Player for ' +
            model + ' application (hereinafter – the “Application”). By using the Application, you agree to be bound by these Terms.' +
            'If you do not agree to these Terms or any portion thereof, you are strictly prohibited from using the Application. </p>' +
            require('../eula');

        page.scrollArea.focus();

        page.scrollArea.init({scroll: scroll, step: 10});

        page.footer = new Footer({
            parent: page,
            visible: true,
            data: {
                middle: [
                    {
                        code: keys.back,
                        title: gettext('Reject the license agreement'),
                        action: function () {
                            require('../components/popup.menu').show();
                        }
                    },
                    {
                        code: keys.ok,
                        disabled: true,
                        title: gettext('Accept the license agreement'),
                        action: function () {
                            // action is required, but no needed to handle this
                        }
                    }
                ]
            }
        });

        page.add(require('../components/popup.menu'));

        page.addListener('show', function () {
            page.scrollArea.init();
            page.footer.init({
                middle: [
                    {
                        code: keys.back,
                        title: gettext('Reject the license agreement'),
                        action: function () {
                            require('../components/popup.menu').show();
                        }
                    },
                    {
                        code: keys.ok,
                        title: gettext('Accept the license agreement'),
                        disabled: true,
                        action: function () {
                            page.scrollArea.move(keys.down);
                        }
                    }
                ]
            });
        });
    });
});


function preventedKeydown ( event ) {
    event.preventDefault();
}


page.addListener('show', function () {
    window.addEventListener('keydown', preventedKeydown);
});


page.addListener('hide', function () {
    window.removeEventListener('keydown', preventedKeydown);
});

page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        // core.call
    }
});


// public
module.exports = page;
